import {
  STOCK_DICTIONARY_FETCH_TRANSLATION_PENDING,
} from '../constants';

export function getDictionaryOptions(id, dictionarySelectedTranslation) {
  return (dispatch) => {
    dispatch({
      type: STOCK_DICTIONARY_FETCH_TRANSLATION_PENDING,
      data: { id, dictionarySelectedTranslation }
    })
  }
}